import { useEntityData } from 'c-data';
import type { Buyer } from 'c-sdk';
import { useCallback, useMemo } from 'react';
import type { NewCampaignFormSchema } from 'c-main/Types';
import { CampaignFormNames } from 'c-main/Types';
import { lineItemCost, lineItemsTotalCost } from 'c-main/Lib/Campaign/lineItemCost';

function useCampaignLineItemCost(buyerId: number) {
    const { getById: GetBuyer } = useEntityData<Buyer>('Buyer');
    const buyer = GetBuyer({ id: buyerId });
    const buyerCost = buyer?.latestCost;

    const getLineItemDaysKey = useCallback(
        (id: number) => `${CampaignFormNames.lineItemDays}.${id}`,
        [],
    );

    const getLineItemStartDateKey = useCallback(
        (id: number) => `${CampaignFormNames.lineItemStartDates}.${id}`,
        [],
    );

    const getLineItemEndDateKey = useCallback(
        (id: number) => `${CampaignFormNames.lineItemEndDates}.${id}`,
        [],
    );

    const getCost = useCallback((days: number) => lineItemCost(days, buyerCost), [buyerCost]);

    const getCostMultiple = useCallback(
        (ids: number[], days: NewCampaignFormSchema['days'], defaultDays: number) =>
            lineItemsTotalCost(ids, days, defaultDays, buyerCost),
        [buyerCost],
    );

    const hasCost = useMemo(() => buyerCost != null, [buyerCost]);
    // const getDateRange = useCallback(
    //     (id: number[]) => {
    //         const total = ids.reduce((runningTotal, lineItemId) => {
    //             return runningTotal + getCost(days?.[lineItemId]?.duration_days ?? defaultDays);
    //         }, 0);
    //
    //         return { total, capped: Math.min(buyerCost?.max_cost ?? 0, total) };
    //         // return Math.ceil(days / buyerCost.days) * buyerCost.cost;
    //     },
    //     [getCost, buyerCost],
    // );

    return {
        getCost,
        getCostMultiple,
        getLineItemDaysKey,
        getLineItemStartDateKey,
        getLineItemEndDateKey,
        hasCost,
    };
}

export default useCampaignLineItemCost;
